import type { WordSense } from "@preptrack/contracts";

interface SenseGroup {
  partOfSpeech: string | null;
  definitions: string[];
}

export function groupWordSenses(senses: WordSense[]): SenseGroup[] {
  const groups = new Map<string | null, SenseGroup>();
  for (const sense of senses) {
    const group = groups.get(sense.partOfSpeech) ?? {
      partOfSpeech: sense.partOfSpeech,
      definitions: [],
    };
    for (const definition of sense.definitionZh.split(/[；;]/).map((item) => item.trim()).filter(Boolean)) {
      if (!group.definitions.includes(definition)) group.definitions.push(definition);
    }
    groups.set(sense.partOfSpeech, group);
  }
  return [...groups.values()];
}

export function sensesToText(senses: WordSense[]) {
  return groupWordSenses(senses)
    .map((group) => `${group.partOfSpeech ? `${group.partOfSpeech} ` : ""}${group.definitions.join("，")}`)
    .join("\n");
}

export function WordSenses({
  senses,
  variant = "default",
  empty = "暂无词典释义",
}: {
  senses: WordSense[];
  variant?: "default" | "compact";
  empty?: string;
}) {
  const groups = groupWordSenses(senses);
  if (groups.length === 0) {
    return variant === "compact"
      ? <span className="word-senses__empty">{empty}</span>
      : <p className="word-senses__empty">{empty}</p>;
  }
  if (variant === "compact") {
    return (
      <span className="word-senses word-senses--compact">
        {groups.map((group, groupIndex) => (
          <span className="word-sense-group" key={`${group.partOfSpeech ?? "other"}-${groupIndex}`}>
            <span className="word-sense-pos">{group.partOfSpeech ?? "补充"}</span>
            <span className="word-sense-definitions">
              {group.definitions.join("，")}
            </span>
          </span>
        ))}
      </span>
    );
  }
  return (
    <dl className={`word-senses word-senses--${variant}`}>
      {groups.map((group, groupIndex) => (
        <div className="word-sense-group" key={`${group.partOfSpeech ?? "other"}-${groupIndex}`}>
          <dt>{group.partOfSpeech ?? "补充"}</dt>
          <dd>
            <p>{group.definitions.join("，")}</p>
          </dd>
        </div>
      ))}
    </dl>
  );
}
